export default __webpack_public_path__ + "static/media/594.43364d21.png";